if (!customElements.get('accordion-media-player')) {
  customElements.define('accordion-media-player', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.video.controls = false;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.disablePictureInPicture = true;
      this.video.disableRemotePlayback = true;
      // Keep the cover visible if the browser blocks automatic playback.
      this.video.play().catch(() => {});
    }
    disconnectedCallback() {
      this.video?.pause();
    }
  });
}
